{
  "name": "gloomhavensecretariat",
  "version": "0.163.0",
  "license": "AGPL3",
  "description": "Gloomhaven Secretariat is a Gloomhaven/Frosthaven Companion app.",
  "homepage": "https://gloomhaven-secretariat.de",
  "author": {
    "name": "Lurkars",
    "email": "contact@gloomhaven-secretariat.de",
    "url": "https://www.champonthis.de"
  },
  "repository": "github:Lurkars/gloomhavensecretariat",
  "bugs": "https://github.com/Lurkars/gloomhavensecretariat/issues",
  "funding": {
    "type": "ko-fi",
    "url": "https://ko-fi.com/lurkars"
  },
  "main": "main.js",
  "nodemonConfig": {
    "execMap": {
      "js": "node ./scripts/build-data.js"
    },
    "watch": [
      "data/"
    ],
    "ext": "json",
    "runOnChangeOnly": true
  },
  "scripts": {
    "prepare": "husky",
    "prestart": "node ./scripts/build-data.js",
    "start": "ng serve",
    "prebuild": "node ./scripts/build-data.js && node ./scripts/pre-build.js",
    "build": "ng build",
    "postbuild": "node ./scripts/post-build.js",
    "pretest": "node ./scripts/build-data.js",
    "test": "ng test",
    "lint": "eslint \"src/**/*.{ts,html}\"",
    "lint:fix": "eslint \"src/**/*.{ts,html}\" --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss}\"",
    "watch": "nodemon",
    "electron": "npm run build -- --configuration electron --base-href ./ && electron . --no-sandbox",
    "electron:build": "npm run build -- --configuration electron --base-href ./ && electron-builder",
    "electron:build:linux:appimage": "npm run build -- --configuration electron --base-href ./ && electron-builder --linux AppImage",
    "patch-android": "node ./scripts/patch-android.js"
  },
  "build": {
    "appId": "gloomhavensecretariat",
    "publish": [
      {
        "provider": "github",
        "owner": "Lurkars",
        "repo": "gloomhavensecretariat"
      }
    ],
    "linux": {
      "target": [
        "AppImage",
        "rpm",
        "deb"
      ]
    },
    "mac": {
      "type": "distribution",
      "target": [
        {
          "target": "dmg",
          "arch": [
            "universal"
          ]
        },
        {
          "target": "pkg",
          "arch": [
            "universal"
          ]
        }
      ]
    },
    "win": {
      "target": "nsis",
      "icon": "build/icon.ico"
    },
    "files": [
      "main.js",
      "dist/gloomhavensecretariat"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "~21.2.13",
    "@angular/common": "~21.2.15",
    "@angular/compiler": "~21.2.15",
    "@angular/core": "~21.2.15",
    "@angular/forms": "~21.2.15",
    "@angular/platform-browser": "~21.2.15",
    "@angular/router": "~21.2.15",
    "@angular/service-worker": "~21.2.15",
    "@capacitor/app": "^8.1.0",
    "@capacitor/core": "^8.3.4",
    "autocompleter": "^9.3.2",
    "electron-updater": "^6.8.8",
    "leaflet": "^1.9.4",
    "mermaid": "^11.15.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.0"
  },
  "devDependencies": {
    "@angular-eslint/schematics": "^21.4.0",
    "@angular/build": "^21.2.13",
    "@angular/cli": "~21.2.13",
    "@angular/compiler-cli": "~21.2.15",
    "@capacitor/android": "^8.3.4",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.3.4",
    "@capacitor/ios": "^8.3.4",
    "@types/dom-screen-wake-lock": "1.0.3",
    "@types/leaflet": "^1.9.21",
    "@types/uuid": "^11.0.0",
    "angular-eslint": "^21.4.0",
    "browserslist": "^4.28.2",
    "electron": "^42.3.0",
    "electron-builder": "26.11.1",
    "eslint": "^10.4.1",
    "eslint-config-prettier": "^10.1.8",
    "http-server": "^14.1.1",
    "husky": "^9.1.7",
    "jsdom": "^29.1.1",
    "lint-staged": "^17.0.7",
    "nodemon": "^3.1.14",
    "prettier": "^3.8.3",
    "prettier-plugin-organize-imports": "^4.3.0",
    "tsx": "^4.22.4",
    "typescript": "~5.9.3",
    "vitest": "^4.1.8"
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "eslint --fix",
      "prettier --write"
    ],
    "src/**/*.scss": [
      "prettier --write"
    ]
  }
}